import { Component, OnInit, inject, ViewChild , ElementRef, Renderer2 } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import { ApiService } from  'src/app/services/api';
import { MatStepperModule, MatStepper } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { Header, Trace } from '../models/trace.model';  // Import the interfaces
import { MsalService } from '@azure/msal-angular';
import { MatDialog  } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'app-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.css'],
    imports: [CommonModule,
        MatStepperModule,
        MatIconModule,
        MatButtonModule,
        MatCardModule]
})
export class TrackingComponent implements OnInit {
  @ViewChild('stepper') private myStepper!: MatStepper;
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private _snackBar = inject(MatSnackBar);
  eventName: string | null = null;
  masterCode: string | null = null;
  eventId :string | undefined;
  pageTitle : string = '';
  loading = false;
  sendingTicket = false;
  header!: Header;  // Store header information
  traces: Trace[] = []; // Array to hold the traces
  noTracesFound = false;
  error:any | null = null;
  userMail ='';
  userName: string | undefined;
  constructor(private location: Location,private apiService: ApiService, private authService: MsalService, private elRef: ElementRef, private renderer: Renderer2, private dialog: MatDialog) {

   }

  ngOnInit(): void {
    if(!this.location.path().includes('/Event/'))
    {
      this.route.queryParamMap.subscribe(params => {
      this.eventName = params.get('EventName');
      this.masterCode = params.get('MasterCode');
      this.pageTitle ='Latest event tracking';
    });
    }
    else
    {
      this.eventId = this.router.url.split('/').pop();
      this.pageTitle ='Event tracking';
    }
    this.getTraces();
  }


  getTraces() {
    this.loading = true;
    this.noTracesFound = false;
    if(this.location.path().includes('/Event/'))
    {
      this.apiService.getDataById(this.eventId!).subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) {
            this.noTracesFound = true;
          } else {
            this.header = data.Header;  // Store the header data separately
            this.traces = data.Traces;  // Store the header data separately
          }
          this.loading = false;

          setTimeout(() => {
            this.changeStepIconColor(this.traces);
          }, 0);      },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      })
    }
    else
    {
      this.apiService.getData(this.eventName, this.masterCode).subscribe({
        next: (data) => {
          console.log(data); // Assign the data to dataSource
          if(data == null) {
            this.noTracesFound = true;
          } else {
            this.header = data.Header;  // Store the header data separately
            this.traces = data.Traces;  // Store the header data separately
          }
          this.loading = false;

          setTimeout(() => {
            this.changeStepIconColor(this.traces);
          }, 0);      },
        error: (message) => {
          console.error(message);
          this.loading = false;
          // General error handling
          this.error = {
            message: 'Failed to fetch logs from the server.',
            details: message || 'Unknown error occurred.'       
          };
        }
      })
    }
  }

  createTicket(trace: Trace) {
    this.sendingTicket = true;
    var loginData = this.authService.instance.getAllAccounts().length > 0;
    let accounts = this.authService.instance.getAllAccounts();
    if(loginData == true) {
      this.userMail = accounts[0].username;
      this.userName = accounts[0].name;
    }
    const requestBody = {
      eventId: this.header.EventId,
      eventName: this.header.EventName,
      masterCode: this.header.MasterCode,
      userMail: this.userMail,
      userName: this.userName,
      trace: trace,
    };

    // Create an observer object
    const observer = {
      next: (response: any) => {
        console.log('POST request was successful', response);
        this.sendingTicket = false;
      },
      error: (error: any) => {
        console.error('POST request failed', error);
        this.sendingTicket = false;
      },
      complete: () => {
        console.log('POST request complete');
        this.sendingTicket = false;
        this._snackBar.open("Ticket was sent to It support !", "✓", {
          duration: 5000,
          panelClass: ['green-snackbar']
        });
      },
    };
    console.log(requestBody);
    // Use the observer in subscribe
    this.apiService.sendTicket(requestBody).subscribe(observer);

  }

  // Method to open confirmation dialog
  openConfirmationDialog(trace: Trace): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '250px',
      data: { message: "Are you sure you want to proceed ?", title: "Create ticket" }
    });
    // After the dialog is closed, do something with the result
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      if (result) {
        this.createTicket(trace);
      } else {
        console.log('User cancelled the action');
      }
    });
  }

  changeStepIconColor(traces: Trace[]) {
    const steps = this.elRef.nativeElement.querySelectorAll('.mat-step-icon');
    steps.forEach((step: HTMLElement, index: number) => {
      if (traces[index].SeverityLevel=== '1') {
        this.renderer.setStyle(step, 'background-color', 'green'); // green color
        this.renderer.setStyle(step, 'color', '#ffffff'); // White text/icon color

      } else if (traces[index].SeverityLevel=== '2') {
        this.renderer.setStyle(step, 'background-color', 'orange'); // Orange color
        this.renderer.setStyle(step, 'color', '#ffffff'); // White text/icon color
      } else if (traces[index].SeverityLevel=== '3') {
        this.renderer.setStyle(step, 'background-color', 'red'); // red color
        this.renderer.setStyle(step, 'color', '#ffffff'); // White text/icon color
      }
    });
  }

  getSeverityColor(severityLevel: string): string {
    switch (severityLevel) {
      case '1':
        return 'green'; // Informational
      case '2':
        return 'orange'; // Warning
      case '3':
        return 'red'; // Critical
      default:
        return 'black'; // Default color
    }
    
  }

  getSeverityLabel(severityLevel: string): string {
    switch (severityLevel) {
      case '1':
        return 'OK'; // Informational
      case '2':
        return 'Warning'; // Warning
      case '3':
        return 'Error'; // Critical
      default:
        return 'Info'; // Default color
    }
    
  }
}